module.exports = __webpack_public_path__ + "img/wsd.e380287c.png";